import { useEffect, useRef } from 'react';
import { CONTENT_QUERY } from '../../../graphql/content/contentQuery';
import { useContentApiLazyQuery } from '../../api/graphql/landa_api';

const useFetchContentByIds = (contentIds: string[]) => {
  const fetchTriggeredRef = useRef(false);
  const [innerRequest, { data, loading, error }] =
    useContentApiLazyQuery(CONTENT_QUERY);

  useEffect(() => {
    if (contentIds.length > 0 && !fetchTriggeredRef.current) {
      fetchTriggeredRef.current = true;
      innerRequest({
        variables: { contentIds: [...contentIds] },
      });
    }
  }, [contentIds]);

  return { content: data, loading, error };
};

export default useFetchContentByIds;
